module.exports = __webpack_public_path__ + "img/u4863.c9ed185b.svg";